import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './Paragraph.less';

export const TEXT_TYPE = {
    PRIMARY: 'Paragraph--primary',
    SECONDARY: 'Paragraph--secondary'
};

export default class Paragraph extends PureComponent {
    static propTypes = {
        children: PropTypes.node.isRequired,
        textType: PropTypes.oneOf(Object.values(TEXT_TYPE))
    };

    static defaultProps = {
        textType: TEXT_TYPE.PRIMARY
    };

    render() {
        const { children, textType } = this.props;

        return (
            <p className={`Paragraph ${textType}`}>{children}</p>
        );
    }
}
